// extracted by mini-css-extract-plugin
export default {"root":"Aq98WDWLYuVzXb4fT83S"};